export enum FirePermitPageVariant {
    READ,
    CREATE,
    CLONE,
}
